import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import ImageUploadBox from 'components/common/ImageUpload';
import LabeledInput from 'components/common/LabeledInput';
import { InvoiceForms, InvoiceFormValues } from 'types';
import { getPresignedUrl, setUploadedPublic } from 'utils/api';

const useStyles = makeStyles((theme) => ({
	imageUploader: {
		marginBottom: 20
	}
}));


interface Props {
    type: keyof InvoiceForms
	invoiceFormValues: InvoiceForms
    setInvoiceFormValueByKey: 
        <T extends keyof InvoiceForms, k extends keyof InvoiceFormValues>
        (type: T, key: k, value: any) => void
    imageUploaderColor: string
    inputColor: string,
    labelInputStyles?: React.CSSProperties;
    labelInputClassName?: string
}

const FormInputs: FC<Props> = ({
    type,
    invoiceFormValues,
    setInvoiceFormValueByKey,
    imageUploaderColor, inputColor, labelInputStyles, labelInputClassName
}) => {
	const classes = useStyles();

    const codePlaceHolder = `參考${ type === 'paper' ? '紙本發票' : '雲端載具' }範例`
    
    const inputFields: {
        key: Exclude<keyof InvoiceFormValues, 'type' | 'filesUrl'>;
        label: string;
        placeholder?: string;
        autoComplete?: string;
    }[] = [
        { key: 'number', label: '發票號碼', placeholder: 'AA00000000'},
        { key: 'date', label: '消費日期', placeholder: '0000/00/00'}, // TODO 換成 date-picker
        { key: 'code', label: type === 'paper' ? '隨機碼' : '載具條碼', placeholder: codePlaceHolder },
        { key: 'name', label: '姓名', autoComplete: 'name' },
        { key: 'phone', label: '聯絡電話', autoComplete: 'tel' },
        { key: 'email', label: '電子信箱', autoComplete: 'email' },
        { key: 'zipcode', label: '郵遞區號', autoComplete: 'postal-code' },
        { key: 'address', label: '獎品寄送地址', autoComplete: 'street-address' }, // TODO TextFiels
    ];

    // TODO upload image 還沒真的串好
	return (<>
		<ImageUploadBox 
			value={ invoiceFormValues[type].filesUrl || '' }
			onUpload={(filename: string) => {
				return getPresignedUrl(filename)
			}}
			onUploaded={(blobname: string) => {
				return setUploadedPublic(blobname)
			}}
			setValue={(val) => {
				setInvoiceFormValueByKey(type, 'filesUrl', val)
			}}
			color={ imageUploaderColor }
			className={ classes.imageUploader }
		/>
        {inputFields.map(({ key, label, placeholder, autoComplete }) => (
            <LabeledInput
                key={key}
                label={label}
                value={invoiceFormValues[type][key] || ''}
                onChange={(val) => setInvoiceFormValueByKey(type, key, val)}
                color={inputColor}
                placeholder={ placeholder || ''}
                style={labelInputStyles}
                className={labelInputClassName}
                autoComplete={autoComplete}
            />
        ))}
	</>);
};

export default FormInputs;
